/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Passwordresetsuccessful2Inputs */

const en_passwordresetsuccessful2 = /** @type {(inputs: Passwordresetsuccessful2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Password Reset Successful`)
};

const de_passwordresetsuccessful2 = /** @type {(inputs: Passwordresetsuccessful2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passwort zurückgesetzt`)
};

/**
* | output |
* | --- |
* | "Password Reset Successful" |
*
* @param {Passwordresetsuccessful2Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const passwordresetsuccessful2 = /** @type {((inputs?: Passwordresetsuccessful2Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Passwordresetsuccessful2Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_passwordresetsuccessful2(inputs)
	return de_passwordresetsuccessful2(inputs)
});
export { passwordresetsuccessful2 as "passwordResetSuccessful" }